import axios from "@/api/config";
const classroom = {
  updateSignRemark(data) {
    return axios.post(
      `${process.env.BASE_URL}/signInRemark/updateSignInRemark`,
      data
    );
  },
  addSignRemark(data) {
    return axios.post(
      `${process.env.BASE_URL}/signInRemark/addSignInRemark `,
      data
    );
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/classroom/pageList`, data);
  },
  updateClassInfoStudent(data) {
    return axios.put(`${process.env.BASE_URL}/classInfoStudent/updateClassInfoStudent`, data);
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/classroom/pageList`, data);
  },
  addClassroom(data) {
    return axios.post(`${process.env.BASE_URL}/classroom/addClassroom`, data);
  },
  updateClassroom(data) {
    return axios.put(`${process.env.BASE_URL}/classroom/updateClassroom`, data);
  },
  deleteClassroom(data) {
    return axios.delete(`${process.env.BASE_URL}/classroom/deleteClassroom`, {
      data: data
    });
  },
  getClassroomList(data) {
    return axios.get(`${process.env.BASE_URL}/classroom/getClassroomList`, {
      params: data
    });
  },
  getClassroomTree(data) {
    return axios.get(`${process.env.BASE_URL}/classroom/getClassroomTree`, {
      params: data
    });
  },
  classroomCalendarInfo(data) {
    return axios.post(
      `${process.env.BASE_URL}/classInfo/classroomCalendarInfo`,
      data
    );
  },

  addKnowledgePoint(data) {
    return axios.post(
      `${process.env.BASE_URL}/knowledgePoint/addKnowledgePoint`,
      data
    );
  },
  updateKnowledgePoint(data) {
    return axios.put(`${process.env.BASE_URL}/knowledgePoint/updateKnowledgePoint`, data);
  },
  getPointList(data) {
    return axios.post(
      `${process.env.BASE_URL}/knowledgePoint/pageList`,
      data
    );
  },
  updateDelayLog(data) {
    return axios.put(`${process.env.BASE_URL}/commonDataStatisticsLog/updateCommonDataStatisticsLog`, data);
  },
  getOperationDelayLogData(data) {
    return axios.post(
      `${process.env.BASE_URL}/commonDataStatisticsLog/delayRecordsList`,
      data
    );
  },
};
export default classroom;



// WEBPACK FOOTER //
// ./src/api/classroom.js